import { Form } from "@client/components/Form";
import styles from "@client/components/FormBlock/form-block.module.scss";
import { toolboxComponents } from "@client/components/PageSkeleton/Toolbox";
import { RichText } from "@client/components/RichText";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.FormPageTemplate & { isSubmitted?: boolean },
) => {
    return (
        <PageSkeleton {...props.page}>
            <StreamField
                value={props.page.body.value}
                components={{
                    ...toolboxComponents,
                    form: ({ value }) => (
                        <section className={styles.root}>
                            {value.header && <RichText value={value.header} />}
                            <Form
                                className={styles.form}
                                form={props.form}
                                pageId={props.page.id}
                                defaultIsSubmitted={
                                    props.is_preview && props.isSubmitted
                                }
                            >
                                {value.results && (
                                    <div className={styles.results}>
                                        <RichText value={value.results} />
                                    </div>
                                )}
                            </Form>
                        </section>
                    ),
                }}
                tagName={React.Fragment}
            />
        </PageSkeleton>
    );
};
